import type { TooltipProps, TypographyProps } from "@mui/material";
import { Tooltip, Typography } from "@mui/material";
import useHorizontalOverflowContainerDetection from "../hooks/useHorizontalOverflowContainerDetection";
import useHorizontalOverflowDetection from "../hooks/useHorizontalOverflowDetection";

interface Props {
  text: string;
  tooltipProps?: Partial<TooltipProps>;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  typographyProps?: TypographyProps;
  observeContainerResize?: boolean;
}

type VariantProps = Omit<Props, "observeContainerResize">;

const TypographyTooltipEllipsis = ({ observeContainerResize, ...rest }: Props) => {
  return observeContainerResize ? <WithContainerDetection {...rest} /> : <WithWindowDetection {...rest} />;
};

const WithWindowDetection = ({ text, tooltipProps, tooltipPlacement, typographyProps }: VariantProps) => {
  const { hasOverflow, containerRef } = useHorizontalOverflowDetection([]);
  return (
    <Tooltip title={hasOverflow ? text : ""} placement={tooltipPlacement} arrow {...tooltipProps}>
      <Typography {...typographyProps} ref={containerRef} noWrap>
        {text}
      </Typography>
    </Tooltip>
  );
};

const WithContainerDetection = ({ text, tooltipProps, tooltipPlacement, typographyProps }: VariantProps) => {
  const { hasOverflow, containerRef } = useHorizontalOverflowContainerDetection([]);
  return (
    <Tooltip title={hasOverflow ? text : ""} placement={tooltipPlacement} arrow {...tooltipProps}>
      <Typography {...typographyProps} ref={containerRef} noWrap>
        {text}
      </Typography>
    </Tooltip>
  );
};

export default TypographyTooltipEllipsis;
